var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"mt-3",attrs:{"no-body":"","type":"dark","bg-variant":"light"}},[_c('b-col',{staticClass:"ml--2"},[_c('h3',{staticClass:"mt-1 ml-1"},[_vm._v("Ergebnis")])])],1),_c('ErgebnisCard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }